module.exports = __webpack_public_path__ + "static/media/user-loc@2x.ff2e90a0.png";